import _ from 'lodash'
import { L2TabularListItemSummary } from '../l2/L2TabularListItem'
import { L2TabularListContent, L2TabularListHeader, L2TabularListRoot } from '../l2/L2TabularList'

export interface L3DMESupplierListModel {
	Status: 'Active'|'Inactive'|'Unknown',
	Description: string,
}

interface L3DMESupplierListProps {
	models?: L3DMESupplierListModel[]
}

const L3DMESupplierList = ({models = []}: L3DMESupplierListProps) => {
	const items = _.map(models, (model, modelIdx) => {
		return (
			<L2TabularListItemSummary key={modelIdx}>
				<div>{model.Status}</div>
				<div>{model.Description}</div>
			</L2TabularListItemSummary>
		)
	})
	return (
		<L2TabularListRoot columnCount={2}>
			<L2TabularListHeader>
				<div>Date of Claim</div>
				<div>DME Description</div>
			</L2TabularListHeader>
			<L2TabularListContent>
				{items}
			</L2TabularListContent>
		</L2TabularListRoot>
	)
}

export default L3DMESupplierList
